import { render, staticRenderFns } from "./ProductQuestionSection.vue?vue&type=template&id=65a4e8d4&"
import script from "./ProductQuestionSection.vue?vue&type=script&lang=js&"
export * from "./ProductQuestionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports